import { render } from "./TextPage5.vue?vue&type=template&id=3a467825"
import script from "./TextPage5.vue?vue&type=script&lang=js"
export * from "./TextPage5.vue?vue&type=script&lang=js"

import "./TextPage5.vue?vue&type=style&index=0&id=3a467825&lang=scss"

import exportComponent from "C:\\Users\\grego\\Documents\\Projets_info\\New-project\\gregoire-aimier-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__